import {
    Component, Prop, Mixins,
} from 'vue-property-decorator';
import CommonProps from '@groot-components/shared/mixins/props';

/**
 * Phone Props
 */
@Component
class Props extends Mixins(CommonProps) {
    /**
     * Make input direction RTL, LTR, Center, or Auto
     */
    @Prop({ default: 'auto' }) dir!: string;

    /**
     * Default Country Code
     */
    @Prop({ type: String }) defaultCountryCode!: String;

    /**
     * Preferred countries
     */
    @Prop({ type: Array }) preferredCountries!: Array<string>;

    /**
     * ignored countries
     */
    @Prop({ type: Array }) ignoredCountries!: Array<string>;

    /**
     * Only countries
     */
    @Prop({ type: Array }) onlyCountries!: Array<string>;

    /**
     * No validator state
     */
    @Prop({ type: Boolean }) noValidatorState!: boolean;

    /**
     * No flags
     */
    @Prop({ type: Boolean }) noFlags!: boolean;

    /**
     * Disabled
     */
    @Prop({ type: Boolean }) disabled!: boolean;

    /**
     * Required
     */
    @Prop({ type: Boolean }) required!: boolean;

    /**
     * Clear input
     */
    @Prop({ type: Boolean }) clearable!: boolean;

    /**
     * Countries height
     */
    @Prop({ type: Number, default: 30 }) countriesHeight!: number;

    /**
     * No use browser locale 
     */
    @Prop({ type: Boolean }) noUseBrowserLocale !: boolean;

    /**
     * No country selector
     */
    @Prop({ type: Boolean }) noCountrySelector !: boolean;

    /**
     * Show code on list
     */
    @Prop({ type: Boolean }) showCodeOnList !: boolean;

    /**
     * No example
     */
    @Prop({ type: Boolean }) noExample !: boolean;

    /**
     * Translations
     */
    @Prop({ type: Object }) translations !: {[k: string]: string};
}

export default Props;
